import {NgModule} from '@angular/core';
import {DateTimePickerComponent} from "./date-time-picker.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatInputModule} from "@angular/material/input";
import {CommonModule} from "@angular/common";
import {
    NGX_MAT_DATE_FORMATS,
    NgxMatDateAdapter,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule
} from "@angular-material-components/datetime-picker";
import {CustomDateFormat} from "./date-time-format";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS, NgxMatMomentAdapter} from "@angular-material-components/moment-adapter";


@NgModule({
    declarations: [
        DateTimePickerComponent,
    ],
    exports: [
        DateTimePickerComponent
    ],
    imports: [
        ReactiveFormsModule,
        FormsModule,
        CommonModule,
        MatDatepickerModule,
        MatInputModule,
        NgxMatDatetimePickerModule,
        NgxMatTimepickerModule,
    ],
    providers: [
        {
            provide: NgxMatDateAdapter,
            useClass: NgxMatMomentAdapter,
            deps: [MAT_DATE_LOCALE, NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: NGX_MAT_DATE_FORMATS, useClass: CustomDateFormat },
        { provide: NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
        { provide: MAT_DATE_LOCALE, useValue: 'fr-BE' },
    ]
})
export class DateTimePickerModule {}
